module.exports = __webpack_public_path__ + "img/하이어쌔신.72d77a52.png";